import React from 'react';
import PropTypes from 'prop-types';
import {LoadingIcon} from '../loadingIcon';
import './Button.css';

export class Button extends React.Component {
  constructor(props) {
    super(props);

    this.unmounted = false;
    this.state = {loading: false};
    this.handleClick = this.handleClick.bind(this);
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleClick() {
    if (this.props.onClick) {
      this.setState({loading: true});
      Promise.resolve(this.props.onClick()).finally(() => {
        if (!this.unmounted) {
          this.setState({loading: false});
        }
      });
    }
  }

  render() {
    const {
      type, // 'button' or 'submit'
      variant, // 'primary', 'secondary', 'link'
      className, // additional classes you want to add,
      disabled, // {true}, {false}, or bool
      onClick, //unused so otherProps won't override our onClick
      ...otherProps
    } = this.props;

    return (
        <button type={type}
                className={'btn btn-' + variant + ' ' + (className || '')}
                onClick={this.handleClick}
                disabled={disabled || this.state.loading}
                {...otherProps}>
          {this.props.children} <LoadingIcon display={this.state.loading}/>
        </button>
    );
  }
}

Button.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
  variant: PropTypes.oneOf(
      ['primary', 'secondary', 'link', 'outline-secondary']),
  href: PropTypes.string,
  className: PropTypes.string,
};
